// The workspace avatar and the rows of the workspace switcher, shared by the sidebar's switcher and
// the plan popup so both show the same menu.
import React from "react";
import { Check } from "lucide-react";

const AVATAR_PALETTE = [
  { bg: "#BA56B033", text: "#A04A97" }, // purple
  { bg: "#0379BA33", text: "#0369A1" }, // blue
  { bg: "#E5860033", text: "#9C5B00" }, // tan
  { bg: "#C7F0D8", text: "#15803D" }, // green
  { bg: "#FBD0DD", text: "#BE185D" }, // pink
  { bg: "#FDE68A", text: "#92400E" }, // amber
];

export const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

const getAvatarColor = (name) => {
  const key = name || "";
  let hash = 0;
  for (let i = 0; i < key.length; i++)
    hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  return AVATAR_PALETTE[hash % AVATAR_PALETTE.length];
};

export const Avatar = ({
  name,
  shape = "square",
  size = 32,
  className = "",
  bg,
  text,
}) => {
  const palette = getAvatarColor(name);
  const bgColor = bg || palette.bg;
  const textColor = text || palette.text;
  return (
    <span
      style={{
        backgroundColor: bgColor,
        color: textColor,
        width: size,
        height: size,
      }}
      className={`flex items-center justify-center flex-shrink-0 font-semibold text-[13px] leading-none ${
        shape === "circle" ? "rounded-full" : "rounded-md"
      } ${className}`}
    >
      {getInitials(name)}
    </span>
  );
};

// One row per workspace; the current one gets the accent bar and a check.
export const WorkspaceMenuItems = ({ workspaces, activeId, onSelect }) =>
  workspaces.map((ws) => {
    const active = String(activeId) === String(ws.id);
    return (
      <button
        key={ws.id}
        type="button"
        onClick={() => onSelect(ws)}
        className="relative w-full flex items-center gap-3 px-3 py-2 text-left hover:bg-[#F5F5F5] rounded-md transition-colors"
      >
        {active && (
          <span className="absolute left-0 top-1.5 bottom-1.5 w-1 rounded-r bg-[#A04A97]" />
        )}
        <Avatar name={ws.name} shape="square" size={36} />
        <div className="flex-1 overflow-hidden">
          <p className="text-[14px] font-medium text-[#000000B3] truncate">{ws.name}</p>
          {typeof ws.member_count === "number" && (
            <p className="text-[12px] text-[#00000080] leading-tight font-normal">
              {ws.member_count} member
              {ws.member_count === 1 ? "" : "s"}
            </p>
          )}
        </div>
        {active && <Check size={16} strokeWidth={2} className="text-[#A04A97] flex-shrink-0" />}
      </button>
    );
  });
